import React from "react";
import { useQueryClient } from "react-query";
import { NodeShareDto, useFileApi } from "~/api/GeneratedApi";
import { API_BASE_URL } from "~/config";
import { emitter } from "~/utils/EventEmitter";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";

type ShareArgs = {
  nodeId: number;
  dto: NodeShareDto;
};
export function useFileShare() {
  const { shareFile } = useFileApi();
  const qc = useQueryClient();
  const share = useCustomMutation(
    ({ nodeId, dto }: ShareArgs) => shareFile(dto, nodeId),
    {
      onSuccess: () => qc.invalidateQueries("shared-files"),
    },
  );

  const getShareLinkFromCode = React.useCallback((code: string): string => {
    emitter.emit("file-shared");
    return `${API_BASE_URL}/api/file/share/${code}`;
  }, []);

  return { share, getShareLinkFromCode };
}
